/**
 * Slim UI agent lock configuration.
 *
 * When LOCKED_AGENT_ID is set, the UI:
 * - Filters sessions to only that agent's sessions
 * - Hides the agent scope picker
 * - Forces new-session creation under that agent
 * - Redirects any URL that references a different agent
 *
 * Set to null/undefined to disable locking (multi-agent mode).
 */
export const LOCKED_AGENT_ID = "ethos-dev" as string | null;
